import { Befehl30FormData, Befehl30FormSchema } from './schema'
import { Befehl30 } from '../../../models'
import {
  Befehl30DataDto,
  BefehlAuftrag_30_10Dto
} from '../../../dtos/befehl-30-dto'
import { createSimpleAuftrag } from '../converter-utils'

export const convertModelToBefehl30FormData = (): Befehl30FormData => {
  return Befehl30FormSchema.parse({})
}

export const convertBefehl30FormDataToModel = (
  _formData: Befehl30FormData,
  frontendId: string
): Befehl30 => {
  const auftraege: Befehl30DataDto = []

  const auftrag30_10 = createSimpleAuftrag(
    '30.10',
    true
  ) as BefehlAuftrag_30_10Dto
  auftraege.push(auftrag30_10)

  return {
    kennung: '30',
    frontendId,
    auftraege
  }
}
